module.exports = __webpack_public_path__ + "img/biter-die-mask1.ef4da399.png";